import { BillingPlan } from "../types";

const FREE_FEATURES = {
  UP_TO_20_SURVEYS_PER_YEAR: "UP_TO_20_SURVEYS_PER_YEAR",
  STRUCTURED_SURVEY_WORKFLOW: "STRUCTURED_SURVEY_WORKFLOW",
  AI_ASSISTED_REPORT_REFINEMENT: "AI_ASSISTED_REPORT_REFINEMENT",
  EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX: "EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX",
  WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS: "WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS",
  EMAIL_SUPPORT: "EMAIL_SUPPORT",
} as const;

const PREMIUM_FEATURES = {
  UP_TO_75_SURVEYS_PER_YEAR: "UP_TO_75_SURVEYS_PER_YEAR",
  STRUCTURED_SURVEY_WORKFLOW: "STRUCTURED_SURVEY_WORKFLOW",
  AI_ASSISTED_REPORT_REFINEMENT: "AI_ASSISTED_REPORT_REFINEMENT",
  EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX: "EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX",
  WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS: "WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS",
  CUSTOM_WORD_REPORT_TEMPLATES: "CUSTOM_WORD_REPORT_TEMPLATES",
  PRIORITY_SUPPORT: "PRIORITY_SUPPORT",
} as const;

const ENTERPRISE_FEATURES = {
  UP_TO_250_SURVEYS_PER_YEAR: "UP_TO_250_SURVEYS_PER_YEAR",
  STRUCTURED_SURVEY_WORKFLOW: "STRUCTURED_SURVEY_WORKFLOW",
  AI_ASSISTED_REPORT_REFINEMENT: "AI_ASSISTED_REPORT_REFINEMENT",
  EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX: "EXPORT_FULLY_EDITABLE_WORD_REPORTS_DOCX",
  WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS: "WORKS_WITH_WORD_PAGES_OR_GOOGLE_DOCS",
  CUSTOM_WORD_REPORT_TEMPLATES: "CUSTOM_WORD_REPORT_TEMPLATES",
  PRIORITY_SUPPORT: "PRIORITY_SUPPORT",
} as const;

export const FEATURES = {
  [BillingPlan.FREE]: FREE_FEATURES,
  [BillingPlan.PREMIUM]: PREMIUM_FEATURES,
  [BillingPlan.ENTERPRISE]: ENTERPRISE_FEATURES,
} as const;

export type Feature =
  | (typeof FREE_FEATURES)[keyof typeof FREE_FEATURES]
  | (typeof PREMIUM_FEATURES)[keyof typeof PREMIUM_FEATURES]
  | (typeof ENTERPRISE_FEATURES)[keyof typeof ENTERPRISE_FEATURES];
